import { CELULAR_PREFIJO_DEFAULT } from '../../../shared/helpers/celular-prefijos.data';
import { UserProfile } from '../../../shared/interfaces/user.interface';
import {
  AgregarPersonaAntecedentesIglesia,
  AgregarPersonaDatosBasicos,
  AgregarPersonaPasoConfirmacion,
  AgregarPersonaSexo,
} from '../agregar-persona-form.interface';

function parseNacimiento(value?: string | null): Date {
  if (!value) {
    return new Date();
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? new Date() : date;
}

function normalizeSexo(value?: string | null): AgregarPersonaSexo {
  const raw = (value ?? '').toLowerCase().trim();
  if (raw === 'mujer' || raw === 'f' || raw === 'female') {
    return 'mujer';
  }
  return 'hombre';
}

export function mapUserToDatosBasicos(user: UserProfile): AgregarPersonaDatosBasicos {
  return {
    nombre: user.nombre ?? '',
    apellido: user.apellido ?? '',
    nombre2: user.nombre2 ?? '',
    prefijo: user.prefijo?.trim() || CELULAR_PREFIJO_DEFAULT,
    celular: String(user.celular ?? ''),
    nacimiento: parseNacimiento(user.nacimiento),
    sexo: normalizeSexo(user.sexo),
  };
}

export function mapUserToAntecedentes(user: UserProfile): AgregarPersonaAntecedentesIglesia {
  return {
    ibaIglesia: false,
    iglesiaAnterior: '',
    tiempoIglesia: '',
    aceptoJesus: false,
    bautizado: user.bautizado === true,
  };
}

export function mapUserToConfirmacion(user: UserProfile): AgregarPersonaPasoConfirmacion {
  return {
    direccion: user.direccion ?? '',
    ciudad: user.localidad ?? '',
    email: user.email ?? '',
    idLider: user.idLider?.trim() || 'sin lider',
    miLider: user.miLider ?? 'sin lider',
    ministerio: user.ministerio?.trim() || 'ninguno',
    nivelPersonal: user.nivelPersonal ?? 0,
    admin: user.admin === true,
    lider: user.lider === true,
    contador: user.contador === true,
  };
}